import styled, { keyframes } from 'styled-components';
import theme from '@/theme';

const bounce = keyframes`
  from {
    width: 0.1rem;
    height: 0.1rem;
    opacity: 1;
    transform: translate3d(0);
  }
  to {
    width: 1rem;
    height: 1rem;
    opacity: 0.1;
    transform: translate3d(0, -1rem, 0);
  }
`;

const OpacityLoaderContainer = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(220, 220, 220, 0.25);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;

  span {
    background: ${theme.colors.themePrimary};
    margin: 5rem 0.5rem;
    animation: ${bounce} 0.6s infinite alternate;
  }

  span:nth-child(2) {
    animation-delay: 0.2s;
  }

  span:nth-child(3) {
    animation-delay: 0.4s;
  }
`;

export const OpacityLoader = () => {
  return (
    <OpacityLoaderContainer>
      <span />
      <span />
      <span />
    </OpacityLoaderContainer>
  );
};
